export function findConnectionByType(element) {
  return element.fType === this.fType;
}
